import { Component } from 'src/utils';
import template from './otpactive.html';


@Component({
  controllerAs: 'otpactivate',
  template
})

export default class OtpActivateContainer {
  static $inject = [
    '$scope',
    '$stateParams',
    '$ngRedux',
    'authActions',
    'authService',
    '$state'
  ];

  constructor($scope, $stateParams, $ngRedux, authActions, authService, $state) {
    const disconnect = $ngRedux.connect(this.mapState)(this);
    this.$state = $state;
    this.$ngRedux = $ngRedux;
    this.$stateParams = $stateParams;
    this.authActions = authActions;
    this.authService = authService;
    this.storeName = $stateParams.storeName;
    this.userInactive = true;
    this.registeredEmail = this.$stateParams.email;
    this.otp = null;
    this.startCountdown(60);
    $scope.$on('$destroy', disconnect);
  }

  mapState(state) {
    return {
      auth: state.auth
    };
  }

  startCountdown(seconds) {
    let counter = seconds;
    let ctrl = this;
    const interval = setInterval(() => {
      var m = Math.floor(counter / 60);
      var s = counter % 60;
      let timerMsg = document.getElementById("timerMsg");
      let resendEmail = document.getElementById("resendEmail");
      if (resendEmail) {
        resendEmail.disabled = true;
      }
      m = m < 10 ? '0' + m : m;
      s = s < 10 ? '0' + s : s;
      counter--;
      if (timerMsg) {
        timerMsg.innerHTML = 'Please wait to resend email for ' + m + ':' + s;
      }
      if (counter < 0) {
        if (resendEmail) {
          resendEmail.disabled = false;
        }
        if (timerMsg) {
          timerMsg.innerHTML = '';
        }
        clearInterval(interval);
      }
    }, 1000);
  }

  submit(form) {
    if (form.$invalid) {
      return;
    }
    this.activationerror = null;
    this.error = null;
    this.authService.oTPactivate({
      id: this.$stateParams.id,
      otp: this.otp
    })
      .then(success => {
        this.userInactive = false;
        this.success = success.data.message;
        setTimeout(() => {
          this.login();
        }, 200);
      })
      .catch(err => {
        this.userInactive = true;
        this.error = err.data.message;
      });
  }
  login() {
    this.$state.go('login');
  }
  resendEmail() {
    this.resendEmailsuccess = null;
    this.resendEmailerror = null;
    if (this.$stateParams && this.$stateParams.email) {
      this.authService.resendEmail({
        id: this.$stateParams.id,
        email: this.$stateParams.email
      })
        .then(success => this.resendEmailsuccess = success.data.message)
        .catch(err => this.resendEmailerror = err.data.message);
        this.startCountdown(60);
    } else {
      this.$state.go('inactive');
    }
  }

}



// WEBPACK FOOTER //
// ./src/app/auth/otpActivation/otpactive.js